import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (route.data['access'] === 'public') return true;
  if (route.data['access'] !== 'protected') {
    return router.createUrlTree(['/auth/error'], { queryParams: { code: 'configuration_required' } });
  }
  const status = await auth.initialize();
  if (status === 'authenticated') return true;
  if (status === 'anonymous') {
    return router.createUrlTree(['/auth/error'], {
      queryParams: { code: 'login_required', returnTo: state.url },
    });
  }
  return router.createUrlTree(['/auth/error'], {
    queryParams: { code: 'service_unavailable', returnTo: state.url },
  });
};